import React from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import Image_ from "../../Image";
import Markdown from "../../Markdown";

const ImageContainerDesktop = styled.div`
    ${({ theme, mobileImage }) =>
        mobileImage &&
        theme.breakpoints.upTo.extraSmall.css`
             display: none;
    `}
`;

const ImageContainerMobile = styled.div`
    display: none;
    ${({ theme }) => theme.breakpoints.upTo.extraSmall.css`
        ${theme.paddings.containerOuter.left}
        ${theme.paddings.containerOuter.right}
       display: block;
    `}
`;

const Text = styled(Markdown)`
    margin-top: 8px;
    font-size: 1em;
    ${({ theme }) => css`
        color: ${theme.colors.blue.toString()};
    `};
`;

const Image = ({ image, text, size = "normal", mobileImage }) => {
    const theme = useTheme();

    const style = css`
        ${size === "large" &&
        css`
            ${theme.paddings.containerOuterInner.left}
            ${theme.paddings.containerOuterInner.right}
        `}
        ${size === "normal" &&
        css`
            padding: 0 500px;
        `}
        ${size === "small" &&
        css`
            padding: 0 700px;
        `}
        ${theme.breakpoints.upTo.small.css`
            ${theme.paddings.containerOuter.left}
            ${theme.paddings.containerOuter.right}
        `}
    `;
    console.log(mobileImage?.src);
    return (
        <>
            <ImageContainerDesktop mobileImage={!!mobileImage?.src} css={style}>
                {image?.src && <Image_ {...image} />}
                {text && <Text>{text}</Text>}
            </ImageContainerDesktop>
            {mobileImage?.src && (
                <ImageContainerMobile>
                    {<Image_ {...mobileImage} />}
                    {text && <Text>{text}</Text>}
                </ImageContainerMobile>
            )}
        </>
    );
};

export default Image;
